import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ButtonDesign from "../../components/ButtonDesign/ButtonDesign";

import "./Footer.css";

const Footer = ({ data, innerRef }) => {
	const navigate = useNavigate();

	const { t } = useTranslation();
	const techStack = t("footer.column1.icons", { returnObjects: true });
	const column3Pages = t("footer.column3.pages", { returnObjects: true });
	const column4Pages = t("footer.column4.pages", { returnObjects: true });

	const handleNavigation = (e, page) => {
		e.preventDefault();
		if (window.location.pathname === "/" + page) {
			window.location.reload();
		} else if (window.location.pathname === "/" && page === " ") {
			window.location.reload();
		} else {
			navigate("/" + page);
		}
	};

	const handleNavigationExternal = (e, page) => {
		e.preventDefault();
		window.open(page, "_blank");
	};

	return (
		<div id="home-footer" ref={innerRef} className="footer-bg">
			<div className="footer-top">
				<h3 className="h3-bold">{t("footer.header")}</h3>
				<ButtonDesign
					data={{
						text: t("footer.button"),
						action: "redirect",
						to: "contacto",
						dynamic: false,
					}}
				/>
			</div>
			<div className="footer-container">
				<div className="footer-container-item footer-container-item-wide">
					<div className="footer-icon">
						<img
							alt={t("footer.column1.image")}
							src={require("../../assets/" + t("footer.column1.image"))}
							className="footer-icon-img "
						/>
					</div>
					<div style={{ width: "237px" }}>
						<h5>{t("footer.column1.text")}</h5>
					</div>
					<div className="card-team-member-icons">
						{techStack.map((item, index) => (
							<div
								className="card-team-member-icon-container"
								key={index}
								onClick={(e) => handleNavigationExternal(e, item["url"])}
							>
								<img
									key={index}
									alt={item["label"]}
									title={item["label"]}
									src={require("../../assets/" + item["image"])}
									className="card-team-member-icon-image"
								/>
							</div>
						))}
					</div>
					<div>
						<h5>{t("footer.column1.created-by")}</h5>
					</div>
				</div>
				<div className="footer-container-item">
					<h3 className="h3-bold footer-head-title">
						{t("footer.column2.title")}
					</h3>
					<h4 className="h4-bold footer-head-subtitle">
						{t("footer.column2.schedule.weekday.title")}
					</h4>
					<h4 className="footer-head-text">
						{t("footer.column2.schedule.weekday.morning")}
					</h4>
					<h4 className="footer-head-text">
						{t("footer.column2.schedule.weekday.afternoon")}
					</h4>
					<h4 className="h4-bold footer-head-subtitle">
						{t("footer.column2.schedule.weekend.title")}
					</h4>
					<h4 className="footer-head-text">
						{t("footer.column2.schedule.weekend.morning")}
					</h4>
				</div>
				<div className="footer-container-item footer-wide">
					<h3 className="h3-bold footer-head-title">
						{t("footer.column3.title")}
					</h3>
					{column3Pages.map((item, index) => (
						<div
							key={index}
							className="footer-text-click"
							onClick={(e) => handleNavigation(e, item["url"])}
						>
							<h4 className="h4-bold footer-head-subtitle">{item["title"]}</h4>
						</div>
					))}
				</div>
				<div className="footer-container-item">
					<h3 className="h3-bold footer-head-title">
						{t("footer.column4.title")}
					</h3>
					{column4Pages.map((item, index) => (
						<div
							key={index}
							className="footer-text-click"
							onClick={(e) => handleNavigation(e, item["url"])}
						>
							<h4 className="h4-bold footer-head-subtitle">{item["title"]}</h4>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Footer;
